import service from '@/store/services/type-line-service';

const state = {
    list: {},
    typeLine: {},
    meta: {}
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, typeLine) => {
        state.typeLine = typeLine;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    list({commit, dispatch}, params) {
        return service.list(params)
            .then(({list, meta}) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get({commit, dispatch}, params) {
        return service.get(params)
            .then((typeLine) => {
                commit('SET_RESOURCE', typeLine);
            });
    },

    add({commit, dispatch}, params) {
        return service.add(params)
            .then((typeLine) => {
                commit('SET_RESOURCE', typeLine);
            });
    },

    update({commit, dispatch}, params) {
        return service.update(params)
            .then((typeLine) => {
                commit('SET_RESOURCE', typeLine);
            });
    },

    destroy({commit, dispatch}, params) {
        return service.destroy(params);
    }
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    typeLine: state => state.typeLine,
};

const typeLines = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default typeLines;
